<template>
  <div class="vx-row">
    <div class="vx-col  xl:w-2/3 ml-auto mr-auto  w-full mb-base">
      <vx-card title="Betalingen">
        <p style="text-align: right; font-style: italic; " class="mb-base">
          Aan dit overzicht kunnen geen rechten worden ontleend of je aan al je
          betalingsverplichtingen hebt voldaan.
        </p>
        <div class="text-right mb-base">
          <vs-button
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-refresh-ccw"
            style="display:inline-block"
            @click="() => getInvoices(true)"
          >
          </vs-button>
        </div>
        <vs-table
          :data="invoices"
          pagination
          max-items="10"
          noDataText="Geen betalingen"
        >
          <template slot="thead">
            <vs-th>Factuurnummer</vs-th>
            <vs-th>Datum</vs-th>
            <vs-th>Soort</vs-th>
            <vs-th class="text-right">Bedrag</vs-th>
            <vs-th>Betaald</vs-th>
            <vs-th v-if="showIdeal">Betalen</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].invoice_number">
                {{ data[indextr].contract_id }}/{{
                  data[indextr].invoice_number
                }}
              </vs-td>
              <vs-td :data="data[indextr].date">
                {{ data[indextr].date | date }}
              </vs-td>
              <vs-td :data="data[indextr].type">
                {{ data[indextr].type }}
              </vs-td>
              <vs-td :data="data[indextr].amount" class="text-right">
                <money-format
                  v-if="data[indextr].amount"
                  :value="data[indextr].amount"
                  locale="nl"
                  currency-code="EUR"
                />
              </vs-td>

              <vs-td :data="data[indextr].status">
                <vs-icon
                  v-if="data[indextr].status == 'Paid'"
                  icon="icon-check"
                  color="success"
                  icon-pack="feather"
                ></vs-icon>
                <span
                  v-if="
                    data[indextr].status == 'Refunded' ||
                      data[indextr].status == 'Error'
                  "
                >
                  <vs-icon
                    icon="icon-x"
                    color="danger"
                    icon-pack="feather"
                  ></vs-icon>
                  {{ $t(`Payment_Error.${data[indextr].status}`) }}
                </span>
              </vs-td>
              <vs-td
                :data="data[indextr].ideal_url"
                v-if="showIdeal"
                class="text-right"
              >
                <a
                  :href="data[indextr].ideal_url"
                  v-if="data[indextr].ideal_url != null"
                  target="_blank"
                >
                  <img
                    :src="require('@/assets/images/ideal.svg')"
                    style="width: 30px; "
                  />
                </a>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from "../axios";
import moment from "moment";
import MoneyFormat from "vue-money-format";

export default {
  data() {
    return { invoices: [] };
  },
  computed: {
    showIdeal() {
      return this.invoices.some(i => i.ideal_url != null);
    }
  },
  components: { MoneyFormat },
  methods: {
    async getInvoices(useCache) {
      this.invoices = [];
      var refresh = useCache ? `?refresh=${new Date().getTime()}` : "";
      var res = await axios().get(`/api/invoice${refresh}`);
      this.invoices = res.data;
    }
  },
  filters: {
    date: function(date) {
      return moment(date)
        .locale("nl")
        .format("LL");
    }
  },

  async created() {
    await this.getInvoices();
  }
};
</script>

<style></style>
